// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Pl4K","banner":"_3j7El","banner__title":"BfL1p","banner__button":"DxWom"};